/**
 * A small subscribable store of tool invocations. Feed it from
 * `registerTools({ onInvoke })`; render it as the live "agent activity
 * feed" every app in this repo uses to make an invisible protocol legible
 * on camera.
 */
export function createActivityLog(options = {}) {
    const limit = options.limit ?? 500;
    let entries = [];
    const listeners = new Set();
    let seq = 0;
    function log(entry) {
        const full = {
            ...entry,
            id: `activity_${Date.now()}_${seq++}`,
            timestamp: Date.now(),
        };
        entries = [full, ...entries].slice(0, limit);
        for (const listener of listeners)
            listener(full, entries);
        return full;
    }
    function subscribe(listener) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    }
    function getAll() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return { log, subscribe, getAll, clear };
}
